<template>
<nav class="navbar navbar-expand-lg navbar-dark bg-light fixed-top">
  <div class="padding container">
    <a class="navbar-brand" href="/">ActionCommons</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item active">
          <a class="nav-link" href="#about">About<span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item active">
          <a class="nav-link " href="/user/login" >Sign In<span class="sr-only">(current)</span></a>
        </li>
      </ul>
    </div>
    </div>
</nav>
</template>

<script>

export default {

}
</script>

<style scoped>
.navbar{
  background-color:#fff !important;
}
.navbar-brand{
  color:#fff;
  font-weight: 1000;
  font-size: 1.4em;
}
.navbar-brand:hover{
  color:#fff;
}
.navbar-nav a {
  color:#fff !important;
  font-weight:700;
  font-size: 1.4em;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.navbar-nav a:hover{
 font-weight: bolder;
 color: aliceblue !important;
 transform:translateX(5px);
}

.navbar-expand-lg {
  background-color:#192440 !important;
}
</style>>
